import { blacklistedTags } from "../config/blacklistedTags";
import { visualizeSnippets } from "../marker";
import { findImageBySrcOrAlt, isHighlightImageOnly } from "../marker/utils";
function scrollToElement(element) {
    // Using requestAnimationFrame to ensure the scrollIntoView is called in the next frame
    // after the browser has completed its current rendering tasks.
    // setTimeout with 0 delay is used to ensure that the element is fully rendered
    // and ready for scrolling before calling scrollIntoView.
    requestAnimationFrame(() => {
        setTimeout(() => {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 0);
    });
}
function getValidElementFromHighlight(highlightId) {
    //@ts-ignore
    for (const [hid, highlight] of CSS.highlights) {
        const id = hid.replace("cw-", "");
        if (highlightId !== id)
            continue;
        for (const range of highlight) {
            let element = range.startContainer.parentElement;
            while (element && blacklistedTags.includes(element.tagName)) {
                element = element.parentElement;
            }
            if (element)
                return element;
            console.error("Element not found for highlight with id:", id);
        }
    }
    return null;
}
function applyScaleAnimation(img) {
    img.style.transform = "scale(1.05)";
    img.style.transition = "all 0.3s";
    setTimeout(() => {
        img.style.transform = "scale(1)";
    }, 300);
}
function waitForScrollToStop(callback, delay = 150) {
    let scrollTimeout;
    const onScroll = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            window.removeEventListener("scroll", onScroll);
            callback();
        }, delay);
    };
    window.addEventListener("scroll", onScroll);
    // Trigger callback immediately if no scrolling occurs within the delay
    scrollTimeout = setTimeout(callback, delay);
}
export function scrollToSnippet(snippet) {
    const element = getValidElementFromHighlight(snippet.id);
    if (element) {
        scrollToElement(element);
    }
    if (isHighlightImageOnly(snippet)) {
        // Extract the src value from the snippet content
        const img = findImageBySrcOrAlt(snippet.content);
        if (img) {
            // This should also allow us to have animation for text highlights
            waitForScrollToStop(() => applyScaleAnimation(img));
        }
    }
}
export function highlightAndScrollToSnippet(snippet) {
    visualizeSnippets([snippet]);
    scrollToSnippet(snippet);
}
export function findSnippet(snippet) {
    let found = false;
    if (getValidElementFromHighlight(snippet.id) || findImageBySrcOrAlt(snippet.content))
        found = true;
    return found;
}
